import { useMemo } from 'react';

import { useGetStartupData } from 'approot/shared/graphql/startup-data/startup-data.hooks';
import type { GetCurrentUserClassQuery } from './classes.apollo.generated';
import { Heading16 } from 'approot/shared/styles/typography.style';
import { spacing4 } from 'approot/shared/styles/spacing.style';
import { SecondaryButtonLink } from 'approot/shared/styles/buttons/secondary-button.style';
import { PRIVATE_CLASSES } from 'global/private-routes.constants';
import {
  formatTeachingYear,
  getCurrentAcademicYear,
} from 'approot/shared/logic/academic-years';
import { pushDataTrackerEvent } from 'approot/shared/data-tracker/data-tracker-push';
import {
  EVENT_ACTION_FOLLOW,
  EVENT_CATEGORY_INFO,
  EVENT_TARGET_TYPE_BANNER,
} from 'approot/shared/data-tracker/data-events.constants';
import * as Styled from './classes-banners.style';
import type { Pluck } from 'lib/gql/pluck';

export const OldClassInfoBanner = ({
  userClass,
}: {
  userClass?: Pluck<GetCurrentUserClassQuery, 'currentUserClass'> | null;
}) => {
  const { data } = useGetStartupData();
  const academicYears = data?.startupData.academicYears;

  const currentTeachingYear = useMemo(
    () => getCurrentAcademicYear({ academicYears }),
    [academicYears]
  );

  return (
    <Styled.ClassesBannerInfo>
      <Heading16 as="h2" marginBottom={spacing4}>
        This class is from{' '}
        {formatTeachingYear(userClass?.terms, { formatShortYear: true })}
      </Heading16>
      <Styled.ClassesBannerInfoText>
        Create or go to your {currentTeachingYear} class to keep using Planner
        for this year.
      </Styled.ClassesBannerInfoText>
      <SecondaryButtonLink
        $isSmall
        to={PRIVATE_CLASSES}
        onClick={() =>
          pushDataTrackerEvent(EVENT_CATEGORY_INFO, EVENT_ACTION_FOLLOW, {
            target_type: EVENT_TARGET_TYPE_BANNER,
            target_identifier: 'old-class-manage-classes',
          })
        }
      >
        Manage Classes
      </SecondaryButtonLink>
    </Styled.ClassesBannerInfo>
  );
};
